// extracted by mini-css-extract-plugin
export default {"marginReset":"PollAnswersDisplay_marginReset__K003o","filters":"PollAnswersDisplay_filters__axruK","dateFilter":"PollAnswersDisplay_dateFilter__13fC1"};